module.exports = __webpack_public_path__ + "img/karen-soger-1.127fd171.png";